import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Alessandra_Title } from '../../../../../utils/ES/Modals/VideoModals';

const ModalVideoAlessandra = () => {
  return (
    <>
      <ModalVideo
        id="alessandra-videoclips"
        dataText={Alessandra_Title}
        videoSrc="https://player.vimeo.com/video/138656497?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_ALESSANDRA"
      />
    </>
  );
};

export default ModalVideoAlessandra;
